<div class="card mb-5" [style.height]="data?.cardHeight" [style.margin-top]="data?.marginTop"
  [style.margin-bottom]="data?.marginBottom">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column align-items-center text-center">
      <h4 style="font-size: calc(16px * var(--dvm-font-scale, 1));">{{ data?.title | capitalCase }}</h4>
    </div>
    <div class="meta-info" *ngIf="metaInfo">
      <span *ngIf="hasMetaValue(metaInfo.totalRecords)">Records: {{ metaInfo.totalRecords }}</span>
      <span *ngIf="hasMetaValue(metaInfo.totalPages)">Pages: {{ metaInfo.totalPages }}</span>
      <span *ngIf="hasMetaValue(metaInfo.pageSize)">Page Size: {{ metaInfo.pageSize }}</span>
    </div>
  </div>

  <div class="card-body">
    <div [id]="data?.widgetId || ''" class="dvm-chart-tall" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 400px)'"
      style="width: 100%;"></div>
  </div>
</div>